import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import deliveryMenKeys from '../util/delivery-men-keys';
import {AccessControlProps} from 'modules/access-controls/types';

const useEditMotorcycle = (accessControlId: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: AccessControlProps) => {
    update(deliveryMenKeys.list(), data);
    setData(deliveryMenKeys.details(accessControlId), data);
  };

  return useApiMutation({
    url: `/access-controls/${accessControlId}/motorcycle`,
    method: 'PATCH',
    errorTitle: 'Erro ao alterar moto',
    successTitle: 'Alterar moto',
    successMessage: 'Moto atualizada com sucesso',
    onSuccess,
  });
};

export default useEditMotorcycle;
